import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home2 from './pages/Home2';
import LocationDetail from './pages/LocationDetail';

const App = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Home2 />} />
      <Route path="/location/:siteId" element={<LocationDetail />} />
    </Routes>
  </Router>
);

export default App;
